import { IRole } from '../redux/slices/rolesSlice'
import { axiosInstance } from './axiosInstance'

export const fetchRoles = async (): Promise<IRole[]> => {
    return axiosInstance
        .get(`/role`)
        .then((response) => {
            return response.data
        })
        .catch(() => {
            return []
        })
}
